import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  showDrawer: false,
  pendingPrompt: null,
  pendingPromptId: null,
};

const parrobotSlice = createSlice({
  name: 'parrobot',
  initialState,
  reducers: {
    toggleShow: (state) => {
      state.showDrawer = !state.showDrawer;
      state.pendingPrompt = null;
      state.pendingPromptId = null;
    },
    showDrawer: (state) => {
      state.showDrawer = true;
      state.pendingPrompt = null;
      state.pendingPromptId = null;
    },
    hideDrawer: (state) => {
      state.showDrawer = false;
      state.pendingPrompt = null;
      state.pendingPromptId = null;
    },
    openParrobotWithPrompt: (state, action) => {
      state.showDrawer = true;
      state.pendingPrompt = action.payload?.prompt || null;
      state.pendingPromptId = Date.now();
    },
    clearPendingPrompt: (state) => {
      state.pendingPrompt = null;
      state.pendingPromptId = null;
    },
  },
});

// Export actions
export const {
  toggleShow,
  showDrawer,
  hideDrawer,
  openParrobotWithPrompt,
  clearPendingPrompt,
} = parrobotSlice.actions;

// Export selectors with descriptive name
export const isParrobotDrawerOpen = (state) => state.parrobot.showDrawer;
export const getParrobotPendingPrompt = (state) => state.parrobot.pendingPrompt;
export const getParrobotPendingPromptId = (state) => state.parrobot.pendingPromptId;

// Export reducer
export const parrobotReducer = parrobotSlice.reducer;
